/* (ignored) */


/*****************
 ** WEBPACK FOOTER
 ** min-document (ignored)
 ** module id = 6
 ** module chunks = 0 1
 **/